import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/IndustriesSlice';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state?.industry || initialState;
export const selectLoading = createSelector([selectDomain], (state) => state.loading);
export const selectFollowedIndustries = createSelector(
  [selectDomain],
  (state) => state.followedIndustries,
);
export const selectIndustriesEmpty = createSelector(
  [selectDomain],
  (state) => state.industriesEmpty,
);
export const selectRecommendedIndustries = createSelector(
  [selectDomain],
  (state) => state.recommendedIndustries,
);
export const newsLoading = createSelector([selectDomain], (state) => state.newsLoading);
export const selectedNewsArticles = createSelector([selectDomain], (state) => state.newsArticles);
export const selectNewsPage = createSelector([selectDomain], (state) => state.newsTabPage);
export const selectedNewsArticlesEnded = createSelector(
  [selectDomain],
  (state) => state.articlesNewsEnded,
);
export const newsFilter = createSelector(
  [selectDomain],
  (state) => state.newsFilter,
);
export const selectedNewsFilter = createSelector(
  [selectDomain],
  (state) => state.selectedNewsFilter,
);
export const selectedPaginationLoading = createSelector(
  [selectDomain],
  (state) => state.paginationLoader,
);
export const selectIndustryName = createSelector(
  [selectDomain],
  (state) => state.industryName,
);
export const selectIndustryAdded = createSelector(
  [selectDomain],
  (state) => state.industryAdded,
);
export const selectIndusFollowLoading = createSelector(
  [selectDomain],
  (state) => state.followLoading,
);

export const selectNewsFlurryObject = createSelector(
  [selectDomain],
  (state) => state.newsFlurry,
);

export const selectSocialFlurryObject = createSelector(
  [selectDomain],
  (state) => state.socialFlurry,
);

export const selectNewsIsCall = createSelector(
  [selectDomain],
  (state) => state.newsApiCall,
);
